import {config} from "../../config/config";

export const getToken = () => {
    const location = {...window.location};
    const embeddedToken = window?.CASHIER_CONFIG?.authToken;
    const urlFirstPart = location.pathname.split("/")[1];
    const urlSecondPart = location.pathname.split("/")[2];
    const urlToken = urlFirstPart !== 'cashier' ? urlFirstPart : urlSecondPart;
    
    return embeddedToken || urlToken || '';
}
export const isTestData = getToken() === 'test-data';
export const getTokenFromUrl = (type = '') => {
    const token =  getToken();
    const testToken = config?.graphqlTestAuthToken
    if(type === 'graphql') {
        if(isTestData && !testToken) {
            const errorText = 'graphqlTestAuthToken in config not provided';

            console.error(errorText);
            return;
        }
        return isTestData ? testToken : token;
    }
    return token;
}
